import packageInfo from '../../package.json';

export const environment = {
  appVersion: packageInfo.version,
  production: false,

  apiEndpoint: "http://localhost:8080/api/"
};
